
































import { Select, Option, OptionGroup } from 'element-ui'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'CustomSelect',
  inheritAttrs: false,
  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
  },
})
export default class CustomSelect extends Vue {
  @Prop() readonly value!: string | number | any[]
  @Prop({ default: '' }) readonly label!: string
  @Prop({ default: '' }) readonly customClass!: string

  isFocused = false

  get isMultiple(): boolean {
    // treat presence of the `multiple` attr (even empty) as true
    const a: any = this.$attrs
    return a && a.multiple !== undefined && a.multiple !== false
  }

  get hasValue(): boolean {
    if (this.isMultiple) {
      return Array.isArray(this.value) && this.value.length > 0
    }
    return !(
      this.value === '' ||
      this.value === null ||
      this.value === undefined
    )
  }

  get hasUserPrefix(): boolean {
    const hasSlot = !!this.$slots.prefix
    const a: any = this.$attrs
    const hasIcon =
      a && (a['prefix-icon'] !== undefined || a.prefixIcon !== undefined)
    return hasSlot || hasIcon
  }

  // Keep v-model working and preserve parent listeners; also manage focus state
  get mergedListeners() {
    const l = this.$listeners as Record<string, any>
    return {
      ...l,
      input: (val: any) => {
        this.$emit('input', val)
        if (typeof l.input === 'function') {
          l.input(val)
        }
      },
      change: (val: any) => {
        if (typeof l.change === 'function') {
          l.change(val)
        }
      },
      focus: (e: FocusEvent) => {
        this.isFocused = true
        if (typeof l.focus === 'function') {
          l.focus(e)
        }
      },
      blur: (e: FocusEvent) => {
        this.isFocused = false
        if (typeof l.blur === 'function') {
          l.blur(e)
        }
      },
      // When dropdown opens, consider it focused; when closes, defer to blur
      'visible-change': (visible: boolean) => {
        if (visible) {
          this.isFocused = true
        }
        if (typeof l['visible-change'] === 'function') {
          l['visible-change'](visible)
        }
      },
    }
  }

  get select(): any {
    return this.$refs.select
  }
  focus() {
    this.select && this.select.focus && this.select.focus()
  }
  blur() {
    this.select && this.select.blur && this.select.blur()
  }
  open() {
    this.select && this.select.toggleMenu && this.select.toggleMenu(true)
  }
  close() {
    this.select && this.select.toggleMenu && this.select.toggleMenu(false)
  }
  clear() {
    this.select && this.select.clear && this.select.clear()
  }
}
